import { AText, Box, Button } from '@alf/uikit';
import { useGeneralRoutes } from '@namespace/cms';
import { useDeviceStore } from '@namespace/device';
import { LocalizedLink, useI18n } from '@namespace/i18n';
import { Image } from '@namespace/icons2';
import { SMARTICO_USER_ERROR_CODE } from '@namespace/layout';

import styles from './index.module.css';

export const RestrictedScreen = ({ errorCode }) => {
  const { t } = useI18n();
  const { isDesktop } = useDeviceStore();
  const { limits, profileDocuments } = useGeneralRoutes();

  const UNVERIFIED_ERRORS = [
    SMARTICO_USER_ERROR_CODE.NOT_VERIFIED,
    SMARTICO_USER_ERROR_CODE.PASSPORT_IN_VERIFICATION,
    SMARTICO_USER_ERROR_CODE.ADDITIONAL_DOCUMENT_REQUIRED
  ];

  const ERROR_CONFIG = {
    DEFAULT: {
      image: 'self_excluded',
      textKey: 'web.lobby.widget.default.notification'
    },
    UNVERIFIED: {
      image: 'unverified',
      textKey: 'web.lobby.widget.unverified.notification',
      buttonTextKey: 'web.lobby.widget.unverified.button',
      showButton: true,
      routeKey: 'profileDocuments'
    },
    [SMARTICO_USER_ERROR_CODE.WITH_LIMIT_MAX_LOSS]: {
      image: 'self_excluded',
      textKey: 'web.lobby.widget.lossLimit.notification',
      buttonTextKey: 'web.lobby.widget.lossLimit.button',
      showButton: true,
      routeKey: 'limits'
    },
    [SMARTICO_USER_ERROR_CODE.SELF_EXCLUDED]: {
      image: 'self_excluded',
      textKey: 'web.lobby.widget.selfExcluded.notification',
      showButton: false
    }
  };

  let configKey = errorCode;
  if (UNVERIFIED_ERRORS.includes(errorCode)) {
    configKey = 'UNVERIFIED';
  }

  const { image, textKey, routeKey, showButton, buttonTextKey } =
    ERROR_CONFIG[configKey] || ERROR_CONFIG.DEFAULT;
  const routes = {
    limits,
    profileDocuments
  };

  return (
    <Box
      className={styles.wrapper}
      justify="center"
      align="center"
      direction="column"
    >
      <Image name={`general/restrictions_${image}`} className={styles.img} />
      <AText
        className={styles.placeholderText}
        breed="BU"
        size={isDesktop ? 'xl' : 'l'}
        color="txt_color_3"
        align="center"
      >
        {t(textKey)}
      </AText>
      {showButton && (
        <Button
          className={styles.buttonPlay}
          component={LocalizedLink}
          to={routes[routeKey]}
          intent="secondary"
          size="m"
          actionType="color3"
        >
          {t(buttonTextKey)}
        </Button>
      )}
    </Box>
  );
};
